import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wkf-configuracao"},[_c(VBreadcrumbs,{staticClass:"systock-breadcrump"},[_c(VBreadcrumbsItem,{attrs:{"title":_vm.breadcrumb}},[_vm._v("\n      "+_vm._s(_vm.breadcrumb)+"\n    ")])],1),_c('autorizacao')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }